import React, { Component } from 'react'

export default class SwitchBox extends Component {
    render() {
        const{label, name, type, id, checked, value,text,onChange} = this.props;
        return (
            <div className="switchkBox d_flex d_flex_align_center">
                    <input type="checkbox" name={name} id={id} checked={checked} onChange={onChange} />
                    <span className="slider round"></span>
                    <label className="switch" htmlFor={id}> {text} </label>
            </div>
        )    
    }
}
